import {
  TextTag,
  TextAlignment,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import type { ReactNode } from 'react';
import {
  HeaderTextWrapper,
  StyledHeaderText,
  StyledSubtitleText,
} from './AccordionHeadline.styles';



interface AccordionHeadlineProps {
  title: ReactNode;
  subtitle?: ReactNode;
}

const AccordionHeadline = ({
  title,
  subtitle,
}: AccordionHeadlineProps) => (
  <HeaderTextWrapper>
    <StyledHeaderText
      textAlign={TextAlignment.left}
      appearance={TokenTextAppearance.bigcopy200}
      tag={TextTag.h2}
    >
      {title}
    </StyledHeaderText>
    {subtitle && (
      <StyledSubtitleText
        textAlign={TextAlignment.left}
        appearance={TokenTextAppearance.label150}
        tag={TextTag.h3}
      >
        {subtitle}
      </StyledSubtitleText>
    )}
  </HeaderTextWrapper>
);

export default AccordionHeadline;
